// Api
import { MatchupCorner } from 'api/graphql-global-types';
import { MatchupFields as Matchup } from 'api/matchup/types/MatchupFields';

export type LiveMatchState = {
  currentMatchupId: string | null;
  currentRound: number;
  roundTimerSeconds: number;
  isTimerRunning: boolean;
  winnerCorner: MatchupCorner | null;
};

export const EMPTY_LIVE_MATCH_STATE: LiveMatchState = {
  currentMatchupId: null,
  currentRound: 1,
  roundTimerSeconds: 0,
  isTimerRunning: false,
  winnerCorner: null,
};

export type FightCompetitorDraft = {
  storeId: string | null;
  name: string;
  avatarURL: string | null;
  invitedEmail: string | null;
  inviteToken: string | null;
};

export const EMPTY_COMPETITOR_DRAFT: FightCompetitorDraft = {
  storeId: null,
  name: '',
  avatarURL: null,
  invitedEmail: null,
  inviteToken: null,
};

export type FightDraft = {
  matchupId: string | null;
  weightClass: string;
  fighterA: FightCompetitorDraft;
  fighterB: FightCompetitorDraft;
  rounds: number | null;
  roundMinutes: number | null;
  isMainEvent: boolean;
};

export const EMPTY_FIGHT_DRAFT: FightDraft = {
  matchupId: null,
  weightClass: '',
  fighterA: { ...EMPTY_COMPETITOR_DRAFT },
  fighterB: { ...EMPTY_COMPETITOR_DRAFT },
  rounds: 1,
  roundMinutes: 3,
  isMainEvent: false,
};

export type { Matchup };
export { MatchupCorner };
